module.exports = __webpack_public_path__ + "img/yuyue.7b547324.png";